// Lightweight transient toast — a fixed bottom-center pill matching the
// navigator mockup's `.toast`. Imperative on purpose: callers just want
// `toast("Project archived")` without wiring React state through the tree.

import "./toast.css";

let el: HTMLDivElement | null = null;
let hideTimer: number | null = null;

function ensureEl(): HTMLDivElement {
  if (el) return el;
  el = document.createElement("div");
  el.className = "toast";
  el.setAttribute("role", "status");
  el.setAttribute("aria-live", "polite");
  document.body.appendChild(el);
  return el;
}

export function toast(message: string): void {
  const node = ensureEl();
  node.textContent = message;
  // Force reflow so re-triggering an already-visible toast re-runs the transition.
  void node.offsetWidth;
  node.classList.add("toast--show");
  if (hideTimer) window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    node.classList.remove("toast--show");
  }, 2600);
}
